import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/renato/projects/apps/pj/cf236/general/general/layouts/default.vue").then(m => m.default || m))
}